export default {
    apiGetEducatorIssueList(data = {}) {
        return this.request(this.api().getEducatorIssueList, data)
            .urltransform(data)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiCreateIssue(data = {}) {
        return this.request(this.api().createIssue, data)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiFileUploaderPublic(data, urldata = {}) {
        return this.request(this.api().fileuploaderpublic, data)
            .urltransform(urldata)
            .multipart()
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiGetIssueCategories(data = {}) {
        return this.request(this.api().getIssueCategories, data)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiGetIssueDetail(data = {}, urldata = {}) {
        const issueId = urldata.issueId || data.issueId;
        return this.request(this.api().getIssueDetail)
            .urltransform({ issueId })
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiUpdateIssue(data = {}, urldata = {}) {
        const issueId = urldata.issueId || data.issueId;
        const payload = { ...data };
        delete payload.issueId;
        return this.request(this.api().updateIssue, payload)
            .urltransform({ issueId })
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiAddIssueComment(data = {}) {
        return this.request(this.api().addIssueComment, data)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiGetIssueComments(data = {}, urldata = {}) {
        const issueId = urldata.issueId || data.issueId;
        return this.request(this.api().getIssueComments)
            .urltransform({ issueId })
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiExportIssues(data = {}) {
        return this.request(this.api().exportIssues, data)
            .responsetype("arraybuffer")
            .exec()
            .log()
            .get();
    },
    apiGetMe(data = {}) {
        return this.request({ url: "/api/v1/profile/me", method: "get" }, data)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiGetIssuePriorities(data = {}) {
        return this.request({ url: "/api/v1/issue-tracker/issue-priority", method: "get" }, data)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiGetAllSchoolList(data = {}) {
        return this.request({ url: "/api/v2/school", method: "get" }, data)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiGetAllSchoolLists(data = {}) {
        return this.request({ url: "/api/v2/school/lists", method: "get" }, data)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiGetIssueKpis(data = {}, urldata = {}) {
        return this.request({ url: "/api/v1/issue-tracker/issue-kpis", method: "get" }, data)
            .urltransform(urldata)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiGetOperationTeamList(data = {}) {
        return this.request({ url: "/api/v1/profile/operation-team/list", method: "get" }, data)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiGetIssueBySchool(data = {}, urldata = {}) {
        return this.request({ url: "/api/v1/issue-tracker/issue-by-school", method: "get" }, data)
            .urltransform(urldata)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiGetIssueByCategory(data = {}, urldata = {}) {
        return this.request({ url: "/api/v1/issue-tracker/issue-by-category", method: "get" }, data)
            .urltransform(urldata)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiGetIssueByPriority(data = {}, urldata = {}) {
        return this.request({ url: "/api/v1/issue-tracker/issue-by-priority", method: "get" }, data)
            .urltransform(urldata)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiGetIssueByDays(data = {}, urldata = {}) {
        return this.request({ url: "/api/v1/issue-tracker/issue-by-days", method: "get" }, data)
            .urltransform(urldata)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    }
};

